import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StripeScriptWrapper from './stripeScriptWrapper';
import CardCapture from './CardCapture';

const Container = styled.div`
  margin: auto;
`;

const StripePayment = ({
  id,
  onClick,
  onSuccess,
  onError,
  confirmingCard,
  aboveSubmitContent,
  disabled,
  hideSubmit,
}) => (
  <Container className="stripe-payment-container">
    <StripeScriptWrapper id={id}>
      <CardCapture
        {...{
          id,
          onClick,
          onSuccess,
          onError,
          confirmingCard,
          aboveSubmitContent,
          disabled,
          hideSubmit,
        }}
      />
    </StripeScriptWrapper>
  </Container>
);

StripePayment.defaultProps = {
  onClick: () => {},
  onSuccess: () => {},
  onError: () => {},
  confirmingCard: false,
  aboveSubmitContent: null,
};

StripePayment.propTypes = {
  onClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  confirmingCard: PropTypes.bool,
  id: PropTypes.string.isRequired,
  hideSubmit: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  aboveSubmitContent: PropTypes.node,
};

export default StripePayment;
